import { Button } from 'antd'
import { AnchorButtonProps } from './types'

const AnchorButton: React.FC<AnchorButtonProps> = ({
  href,
  onClick,
  children,
  ...rest
}) => (
  <Button
    {...rest}
    href={href ?? undefined}
    onClick={(e) => {
      e.preventDefault()
      if (href) window.open(href)
      onClick?.(e)
    }}
  >
    {children}
  </Button>
)

export default AnchorButton
